import React, { memo, useState, useEffect } from 'react';

function DegreeIntegration(props) {
  const { answer, options } = props;
  const [level, setLevel] = useState(answer);
  useEffect(() => {
    setLevel(parseInt(answer));
  }, [answer]);
  // const texts = ['Minimal', 'Partial', 'Full'];
  const texts = [
    'Very little experience',
    'Limited experience',
    'Moderate experience',
    'Significant experience',
    'Well-oiled machine',
  ];

  return (
    <div className="degree-integration-box">
      <div className="block-box">
        {texts.map((text, idx) => (
          <div
            key={idx}
            className="block"
            onClick={() => {
              setLevel(idx + 1);
              props.changeAnswerValue(idx + 1);
            }}
          >
            <div
              className={`${
                level > idx && 'active-indicator-block'
              } indicator-block`}
            />
            <div
              className={`level-bar ${level === idx + 1 && 'active-level-bar'}`}
            />
            <div className={`text ${level === idx + 1 && 'active-text'}`}>
              {text}
            </div>
            <div
              className={`triangle-mark ${
                level === idx + 1 && 'active-triangle-mark'
              }`}
            />
            <div className="bottom-bar" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default memo(DegreeIntegration);
